
export default function Hero() {
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[90vw] aspect-square bg-[#9b87f5] opacity-10 rounded-full blur-[100px] md:blur-[150px] md:max-w-[500px]"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="mb-6">
            <img 
              src="https://i.ibb.co/mrvb320Q/PXL-20260417-144350652-MP-1-1.jpg" 
              alt="Aram AI" 
              className="w-24 h-24 rounded-full object-cover border-2 border-white/20 mx-auto"
            />
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-6 glow-text">
            AI builder
          </h1>
          
          <p className="text-xl text-gray-300 mb-10">
            Solo agency work, my own SaaS products, and everything I'm learning along the way.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://www.youtube.com/@iamaramai" 
              target="_blank"
              rel="noopener noreferrer"
              className="gradient-border inline-block w-fit mx-auto sm:mx-0 transition-transform active:scale-95 duration-200"
            >
              <button className="px-8 py-3 bg-black rounded-lg font-medium text-white hover:bg-opacity-80 transition-all w-full">
                Follow on YouTube
              </button>
            </a>
            
            <a 
              href="#articles" 
              className="px-8 py-3 rounded-lg font-medium text-white border border-white/20 hover:bg-white/5 transition-all active:scale-95 duration-200"
            >
              Read the blog
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
